import { render, staticRenderFns } from "./WithActionNotificationSection.vue?vue&type=template&id=6b5d2744&scoped=true&"
import script from "./WithActionNotificationSection.vue?vue&type=script&lang=ts&"
export * from "./WithActionNotificationSection.vue?vue&type=script&lang=ts&"
import style0 from "./WithActionNotificationSection.vue?vue&type=style&index=0&id=6b5d2744&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d2744",
  null
  
)

export default component.exports